import {createReducer, on} from '@ngrx/store';
import {UserViewConfigState} from '../states/user-view-config.state';
import {UserViewConfigActions} from '../action/user-view-config.actions';


export const userViewConfigInitial: UserViewConfigState = {
  meta: {
    isValidConfigAvailable: false,
    isInitCheckDone: false,
    error: undefined,
    loading: false
  }
};

export const userViewConfigReducer = createReducer(
  userViewConfigInitial,

  on(
    UserViewConfigActions.createUserViewConfig,
    UserViewConfigActions.updateUserViewConfig,
    (state) => ({
      ...state,
      meta: {
        ...state.meta,
        loading: true
      }
    })
  ),

  on(
    UserViewConfigActions.readUserViewConfigSuccess,
    UserViewConfigActions.createUserViewConfigSuccess,
    UserViewConfigActions.updateUserViewConfigSuccess,
    (state, {config}) => ({
      ...state,
      ...config,
      meta: {
        isValidConfigAvailable: true,
        isInitCheckDone: true,
        error: undefined,
        loading: false
      }
    })
  ),

  on(
    UserViewConfigActions.readUserViewConfigFailure,
    (state, {error}) => ({
      ...state,
      meta: {
        isValidConfigAvailable: false,
        isInitCheckDone: true,
        error: error.status === 404 ? undefined : error,
        loading: false
      }
    })
  ),

  on(
    UserViewConfigActions.createUserViewConfigFailure,
    UserViewConfigActions.updateUserViewConfigFailure,
    (state, {error}) => ({
      ...state,
      meta: {
        ...state.meta,
        error,
        loading: false
      }
    })
  )
);
